// Add your custom JS here.
jQuery(document).ready(function($) {
	var windowWidth = $(window).innerWidth();

    //console.log("tailles",elementorFrontend.config.responsive.breakpoints);
    if (elementorFrontend.config.responsive.breakpoints) {

        var windowMinWidth = elementorFrontend.config.responsive.breakpoints.tablet.value;
    } else {
        var windowMinWidth = 768;
    }
    var windowResponsiveMobile = windowWidth < windowMinWidth;
    function swapChildren(obj1, obj2) {
        var temp = obj2.children().detach();
        obj2.empty().append(obj1.children().detach());
        obj1.append(temp);
    }
    function toggleMobileStyles() {
        console.log("toggleMobileStyles");
        console.log("breakpoints", elementorFrontend.config.responsive.breakpoints);
        if (windowResponsiveMobile) {
            console.log('on passe le desktop en mobile');
            $("[id^='_desktop_']").each(function (idx, el) {
                var target = $('#' + el.id.replace('_desktop_', '_mobile_'));
                if (target.length) {
                    swapChildren($(el), target);
                }
            });
        } else {
            console.log('on passe mobile en desktop');
            $("[id^='_mobile_']").each(function (idx, el) {
                var target = $('#' + el.id.replace('_mobile_', '_desktop_'));
                if (target.length) {
                    swapChildren($(el), target);
                }
            });
        }
    }
    $(window).on('resize', function () {
        var _cw = windowWidth;
        var _mw = windowMinWidth;
        var _w = $(window).innerWidth();
        var _toggle = _cw >= _mw && _w < _mw || _cw < _mw && _w >= _mw;
        windowWidth = _w;
        windowResponsiveMobile = windowWidth < windowMinWidth;
        //console.log('_toggle', _toggle)
        if (_toggle) {
            toggleMobileStyles();
        }
    });
    $(document).ready(function () {
        if (windowResponsiveMobile) {
            toggleMobileStyles();
        }
    });
});